import setupComponents from './setup_components'
import store from 'client/javascripts/redux/store'
import { bookProductToCart } from 'client/javascripts/redux/actions/cart'
import { showEssentialsModal } from 'client/javascripts/helpers/essentialsModal'
import { showWishlistModal } from 'client/javascripts/helpers/wishlistModal'
import { notification } from 'client/javascripts/react/components/Notification'
import tweakwisePriceUpdater from 'client/javascripts/utils/tweakwisePriceUpdater'

setupComponents(store)

import $ from 'jquery';
import { i18n } from './localized-i18n.js'

const images = require.context('client/images', true)
const imagePath = (name) => images(name, true)

// Initialize Stimulus controllers
import "../controllers"

import 'client/javascripts/app'

// Import Turbo AFTER Turbolinks has been initialized (in client/javascripts/app)
// Disable Turbo Drive to avoid conflicts with Turbolinks - we only use Turbo Frames
document.addEventListener('turbolinks:load', () => {
  import("@hotwired/turbo-rails").then(({ Turbo }) => {
    Turbo.session.drive = false
    window.Turbo = Turbo
  })
}, { once: true })

window.$ = $;
window.jQuery = $;
window.i18n = i18n;
window.reduxStore = store;
window.bookProductToCart = bookProductToCart;
window.showEssentialsModal = showEssentialsModal;
window.showWishlistModal = showWishlistModal;
window.notification = notification;
window.tweakwisePriceUpdater = tweakwisePriceUpdater;
